import React from 'react';
import { useQuery } from '@apollo/react-hooks';
import { getPath } from '@express-labs/raven-tools';
import getFromStorage from '../../../../helpers/storage/storage';
import { getMemberWallet, getOrderSummary } from '../../../../queries';
import MemberWalletHeader from './MemberWalletHeader';

function MemberWalletHeaderVM() {
  const loyaltyWarmStateData = getFromStorage('loyaltyWarmStateData', {});
  const loyaltyId = loyaltyWarmStateData.loyaltyNumber || '';
  const { loading, error, data } = useQuery(getMemberWallet, { variables: { loyaltyId } });
  const { data: orderSummary } = useQuery(getOrderSummary, {
    variables: {
      shouldRecalculateTax: false,
    },
  });
  const walletCouponCode = getPath(
    orderSummary,
    'orderSummary.promotions.0.walletCouponCode',
    null,
  );
  const couponCode = getPath(orderSummary, 'orderSummary.promotions.0.code', null);
  const appliedCode = walletCouponCode || couponCode;

  return (
    <MemberWalletHeader
      appliedCode={appliedCode}
      loading={loading}
      error={error}
      data={data}
    />
  );
}

export default MemberWalletHeaderVM;
